export enum StorageKey {
  previousSessionExpiredMessage = "previousSessionExpiredMessage",
  loginViaSso = "loginViaSso",
  pubnubSubscriptionKey = "user_pubnubSubscriptionKey",
  jwt = "jwt",
  user = "user",
  broadcastChannels = "user_broadcastChannels",
  googleMapsApiKey = "user_googleMapsApiKey",
  storageMode = "storageMode",
  ssoSignOutUrl = "signOutUrl",
}

const fieldsToPreserveBetweenSessions: string[] = [StorageKey.loginViaSso, StorageKey.storageMode];
const fieldsToCopyFromLocalStorage: string[] = [StorageKey.jwt];

export enum StorageMode {
  clearWhenWebSessionEnds = "clearWhenWebSessionEnds",
  normal = "normal",
}

const getStorage = (): Storage => {
  return localStorage.getItem(StorageKey.storageMode) === StorageMode.clearWhenWebSessionEnds
    ? window.sessionStorage
    : window.localStorage;
};

let storage: Storage = getStorage();

export const storageService = {
  setMode(mode: StorageMode): void {
    localStorage.setItem(StorageKey.storageMode, mode);
    switch (mode) {
      case StorageMode.clearWhenWebSessionEnds:
        for (const key in window.localStorage) {
          const value = window.localStorage.getItem(key);
          if (fieldsToCopyFromLocalStorage.includes(key) && value && !sessionStorage.getItem(key)) {
            window.sessionStorage.setItem(key, value);
          }
          if (!fieldsToPreserveBetweenSessions.includes(key)) {
            window.localStorage.removeItem(key);
          }
          storage = window.sessionStorage;
        }
        break;
      case StorageMode.normal:
        storage = window.localStorage;
        break;
      default:
        throw new Error("unknown storage type");
    }
  },

  getItem(key: StorageKey | string): string | null {
    return storage.getItem(key);
  },
  /**
   * @param key prefer to use StorageKey until you have a reason to use string
   * good reason to use string is when your key is dynamic ie key depends on the user id, for example
   */
  getItemAsObject<T>(key: StorageKey | string): T | null {
    const value = storage.getItem(key);
    if (value) {
      return JSON.parse(value) as T;
    }
    return null;
  },
  save(key: StorageKey | string, value: unknown, stringify = true): void {
    storage.setItem(key, stringify ? JSON.stringify(value) : (value as string));
  },
  removeItem(key: StorageKey | string): void {
    storage.removeItem(key);
  },
  clear(): void {
    storage.clear();
  },
};

export default storageService;
